export const modalMixin = {
  methods: {
    /**
     * Centraliza um modal na viewport visível
     * @param {HTMLElement} modalRef - Referência do elemento modal
     */
    centralizarModal(modalRef) {
      this.$nextTick(() => {
        if (modalRef) {
          const modal = modalRef;
          
          // Resetar estilos inline
          modal.style.position = '';
          modal.style.margin = '';
          modal.style.transform = '';
          modal.style.top = '';
          modal.style.left = '';
          modal.style.right = '';
          modal.style.bottom = '';
          modal.style.transition = '';
          modal.style.opacity = '';
          
          // Forçar reflow
          modal.offsetHeight;
          
          // Obter dimensões da viewport
          const viewportHeight = window.innerHeight;
          const viewportWidth = window.innerWidth;
          
          // Aplicar posicionamento absoluto para centralização precisa
          modal.style.position = 'fixed';
          modal.style.top = '50%';
          modal.style.left = '50%';
          modal.style.transform = 'translate(-50%, -50%)';
          modal.style.zIndex = '9999';
          modal.style.maxHeight = '90vh';
          modal.style.maxWidth = '90vw';
          modal.style.overflow = 'auto';
          
          // Aplicar animação de entrada
          modal.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
          modal.style.opacity = '0';
          modal.style.transform = 'translate(-50%, -50%) scale(0.9)';
          
          // Forçar reflow e aplicar animação final
          setTimeout(() => {
            modal.style.opacity = '1';
            modal.style.transform = 'translate(-50%, -50%) scale(1)';
          }, 10);
          
          // Verificar se o modal está dentro da viewport após animação
          setTimeout(() => {
            const rect = modal.getBoundingClientRect();
            
            // Se o modal estiver muito grande para a viewport, ajustar
            if (rect.height > viewportHeight * 0.9) {
              modal.style.maxHeight = '90vh';
              modal.style.overflowY = 'auto';
            }
            
            if (rect.width > viewportWidth * 0.9) {
              modal.style.maxWidth = '90vw';
              modal.style.overflowX = 'auto';
            }
            
            // Garantir que está centralizado
            modal.style.top = '50%';
            modal.style.left = '50%';
            modal.style.transform = 'translate(-50%, -50%)';
          }, 300);
        }
      });
    },

    /**
     * Reseta a posição de um modal
     * @param {HTMLElement} modalRef - Referência do elemento modal
     */
    resetModalPosition(modalRef) {
      if (modalRef) {
        // Resetar estilos inline
        modalRef.style.transform = '';
        modalRef.style.top = '';
        modalRef.style.left = '';
        modalRef.style.right = '';
        modalRef.style.bottom = '';
        modalRef.style.transition = '';
        modalRef.style.opacity = '';
        modalRef.style.position = '';
        modalRef.style.zIndex = '';
        modalRef.style.maxHeight = '';
        modalRef.style.maxWidth = '';
        modalRef.style.overflow = '';
      }
    },

    /**
     * Centraliza todos os modais Bootstrap Vue na página
     */
    centralizarBootstrapModals() {
      this.$nextTick(() => {
        // Encontrar todos os modais Bootstrap Vue
        const modals = document.querySelectorAll('.modal-dialog');
        
        modals.forEach(modal => {
          // Aplicar estilos para centralização
          modal.style.position = 'fixed';
          modal.style.top = '50%';
          modal.style.left = '50%';
          modal.style.transform = 'translate(-50%, -50%)';
          modal.style.zIndex = '1055';
          modal.style.maxHeight = '90vh';
          modal.style.maxWidth = '90vw';
          modal.style.overflow = 'auto';
        });
      });
    },

    /**
     * Adiciona listener para centralizar modais quando a janela é redimensionada
     */
    adicionarListenerResize() {
      const handleResize = () => {
        // Centralizar modais Bootstrap Vue
        this.centralizarBootstrapModals();
        
        // Centralizar modais customizados
        const customModals = document.querySelectorAll('[ref*="modal"], .modal-content');
        customModals.forEach(modal => {
          if (modal.style.position === 'fixed') {
            this.centralizarModal(modal);
          }
        });
      };

      window.addEventListener('resize', handleResize);
      
      // Remover listener quando o componente for destruído
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', handleResize);
      });
    }
  },

  mounted() {
    // Adicionar listener de resize
    this.adicionarListenerResize();
    
    // Centralizar modais Bootstrap Vue existentes
    this.centralizarBootstrapModals();
  }
};
